module.exports = __webpack_public_path__ + "img/l1.7039ad9b.png";